// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"65":"b6bf1a61","162":"7b2fcdde","256":"daa910c8","499":"67029604"}[chunkId] + ".chunk.css";
};